// extracted by mini-css-extract-plugin
export default {"mainContainer":"main_mainContainer__ngBdN","outlinedBtn":"main_outlinedBtn__-zs9i","outlinedBtnBottom":"main_outlinedBtnBottom__Tvegn"};